import { useQuery } from '@tanstack/react-query';
import { fetchScopedProducts } from '../services/security-groups';
import type { SecurityProductListResponse } from '../types/security-admin.types';

const MAX_SEARCH_LENGTH = 100;

export function useScopedProductsQuery(ownerDealerId: string | undefined, search: string) {
  const trimmed = search.trim().slice(0, MAX_SEARCH_LENGTH);
  const effectiveSearch = trimmed.length >= 2 ? trimmed : undefined;

  return useQuery<SecurityProductListResponse>({
    queryKey: ['security-admin', 'scoped-products', ownerDealerId, effectiveSearch ?? ''],
    queryFn: () => {
      if (!ownerDealerId) throw new Error('ownerDealerId is required');
      return fetchScopedProducts(ownerDealerId, { search: effectiveSearch, per_page: 200 });
    },
    enabled: Boolean(ownerDealerId),
    staleTime: 2 * 60 * 1000,
  });
}
